import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function Breadcrumb({ items }: { items: Array<{ label: string; href?: string }> }) {
  return (
    <nav className="mb-6 flex items-center gap-1 text-xs text-gray-500">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1">
          {item.href ? (
            <Link to={item.href} className="hover:text-teal">
              {item.label}
            </Link>
          ) : (
            <span className="text-dark">{item.label}</span>
          )}
          {i < items.length - 1 && <ChevronRight className="h-3 w-3 text-gray-400" />}
        </span>
      ))}
    </nav>
  );
}
